export default {"src":"/_next/static/media/logo-white.7a0ba5e9.svg","height":24,"width":157};